import { Router } from '@angular/router';
import { BurbujaService } from './../../services/burbuja.service';
import { Component, OnInit } from '@angular/core';
import { TokenAdmService } from 'src/app/services/token-adm.service';
import Swal from 'sweetalert2';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Params } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-burbujas',
  templateUrl: './burbujas.component.html',
  styleUrls: ['./burbujas.component.css'],
})
export class BurbujasComponent implements OnInit {
  burbujas: any = [];
  ruta: string;
  loading: boolean;
  isAdmin: boolean;
  isContribuidor: boolean;
  editar: boolean = true;
  ordenar: boolean = false;
  burbujasTempo: any;
  origen: string;

  constructor(
    private burbujaService: BurbujaService,
    private router: Router,
    private tokenService: TokenAdmService,
    private route: ActivatedRoute,
    private authService: MsalService
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.route.queryParams.subscribe((params) => {
      this.origen = params.origen;
      if (this.origen != undefined) {
        let sesionIniciada = this.tokenService.verificaUsuario();
        if (!sesionIniciada) {
          this.authService.loginRedirect();
          this.ruta = 'help';
          this.router.navigateByUrl(this.ruta);
          sessionStorage.setItem('privado', 'SI');
        }
      }
    });
    this.burbujaService.getBurbujasActivasPublic().subscribe(
      (resp) => {
        this.burbujas = resp;
        sessionStorage.setItem('origen', '');
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.loading = false;
      }
    );
    this.isAdmin = this.tokenService.hasRole('Help_Admin');
    this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor');
  }

  verTemas(burbujaId: string, burbuja: string) {
    this.ruta = 'help/temas/' + burbujaId;
    sessionStorage.setItem('burbujaId', burbujaId);
    sessionStorage.setItem('burbujaDesc', burbuja);
    this.router.navigateByUrl(this.ruta);
    sessionStorage.setItem('buscado', '');
  }

  habilitarOrdenar() {
    this.ordenar = true;
    this.editar = false;
    this.burbujasTempo = JSON.parse(JSON.stringify(this.burbujas));
  }

  cancelarOrdenar() {
    this.ordenar = false;
    this.editar = true;
    this.burbujas = this.burbujasTempo;
  }

  guardarOrdenamiento() {
    let timerInterval;
    Swal.fire({
      title: 'Confirmación',
      html: '¿Confirmas que queres guardar los cambios en el ordenamiento que hiciste?',
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
        });
        Swal.showLoading();
        this.burbujaService.cambiarOrden(this.burbujas).subscribe({
          next: (resp) => {
            Swal.fire({
              title: 'Cambios guardados correctamente',
              text: 'El ordenamiento ha sido guardado correctamente en la base de datos',
              icon: 'success',
              timer: 1500,
              timerProgressBar: true,
              willClose: () => {
                clearInterval(timerInterval);
                this.ordenar = false;
                this.editar = true;
              },
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector('b');
                timerInterval = setInterval(() => {
                  if (b) {
                    b.textContent = Swal.getTimerLeft()?.toString();
                  }
                }, 100);
              },
            }).then((resp) => {
              if (resp.isConfirmed) {
                this.ordenar = false;
                this.editar = true;
              }
            });
          },
          error: (error) => {
            console.error(error.error);
            Swal.fire({
              title: 'No se pudo actualizar el ordenamiento',
              text: 'Ocurrió un error al intentar actualizar en la base de datos el ordenamiento',
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          },
        });
      }
    });
  }

  nuevaBurbuja() {
    sessionStorage.setItem('origen', '');
    sessionStorage.setItem('origenBurbuja', location.pathname);
    this.ruta = 'help/burbuja/' + 0;
    this.router.navigateByUrl(this.ruta);
  }

  editarBurbuja(burbujaId: number) {
    sessionStorage.setItem('origen', '');
    sessionStorage.setItem('origenBurbuja', location.pathname);
    this.ruta = 'help/burbuja/' + burbujaId;
    this.router.navigateByUrl(this.ruta);
  }

  borrarBurbuja(burbujaId: number, nombreBurbuja: string) {
    let cantidadTemas = 0;
    let texto: string;
    this.burbujaService.contarTemas(burbujaId).subscribe({
      next: (resp: number) => {
        cantidadTemas = resp;
        if (cantidadTemas > 0) {
          if (cantidadTemas == 1) {
            texto = `¿Estas seguro que deseas borrar esta burbuja? <br><b>${nombreBurbuja}</b> <br>La burbuja tiene ${cantidadTemas} tema asociado.`;
          } else {
            texto = `¿Estas seguro que deseas borrar esta burbuja? <br><b>${nombreBurbuja}</b> <br>La burbuja tiene ${cantidadTemas} temas asociados.`;
          }
        } else {
          texto = `¿Estas seguro que deseas borrar esta burbuja? <br><b>${nombreBurbuja}</b> <br>La burbuja no tiene temas asociados.`;
        }

        Swal.fire({
          title: 'Borrar burbuja',
          html: texto,
          showDenyButton: true,
          confirmButtonText: `Si`,
          denyButtonText: `No`,
          icon: 'question',
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: 'Espera por favor',
              text: 'Guardando la información',
              allowOutsideClick: false,
              timerProgressBar: true,
            });
            Swal.showLoading();
            let timerInterval;
            this.burbujaService.eliminarBurbuja(burbujaId).subscribe({
              next: (data) => {
                this.reload();
                Swal.fire({
                  title: 'Burbuja borrada',
                  text: `La burbuja "${nombreBurbuja}" ha sido borrada con exito`,
                  icon: 'success',
                  timer: 1500,
                  timerProgressBar: true,
                  willClose: () => {
                    clearInterval(timerInterval);
                  },
                  didOpen: () => {
                    Swal.showLoading();
                    const b = Swal.getHtmlContainer().querySelector('b');
                    timerInterval = setInterval(() => {
                      if (b) {
                        b.textContent = Swal.getTimerLeft()?.toString();
                      }
                    }, 100);
                  },
                });
              },
              error: (error) => {
                console.error(error.error);
                Swal.fire({
                  title: 'No se pudo borrar la burbuja',
                  text: `Ocurrió un error al borrar la burbuja ${nombreBurbuja}`,
                  icon: 'error',
                  confirmButtonText: 'Ok',
                });
              },
            });
          }
        });
      },
    });
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }

  drop(evento: CdkDragDrop<any>) {
    moveItemInArray(this.burbujas, evento.previousIndex, evento.currentIndex);
    evento.container.data.forEach((x, index) => {
      x.orden = index;
    });
  }
}
